import { Faq } from './../faq';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from './../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryParam } from './../query-param';
import { Config } from './../config';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  mobileNumber: number | undefined;
  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private titleService: Title,
    private modal: NgbModal
  ) {}
  queryParam!: QueryParam;
  gameConfig: Config = {} as Config;
  faq!: Faq[];

  portalIds = ['6', '16', '32', '48', '87', '149', '152', '170', '197', 
  '200', '286', '295', '296', '298', '305', '320', '322', 
  '325', '327', '334', '335', '364', '370', '371', '375', '376'];

operatorIds = ['2032', '2150', '2209', '2022', '2049', '2050', '2025', '4464',
    '2217', '2104', '2105', '5573', '8966', '9073', '9071', '2009', '2010',
    '2032', '2150', '2209', '9038', '2022', '2028', '2029', '2049', '2050', '2212',
    '2213', '2214', '2215', '2216', '2217', '2218', '2103', '7803', '2100', '2151', '9032',
    '9041', '2032'];

  ngOnInit() {
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );

    //this.getConditionalDialogBox();

    this.getConfigData(this.queryParam.id, this.queryParam.lang,this.queryParam.theme);
    this.getFaqData(this.queryParam.id, this.queryParam.lang);
    window.scrollTo(0, document.body.scrollHeight / 2);
  }

  getGameConfig() {
    this.gameConfig.sliderName = 'slider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/carousel-1.png',
      'assets/images/slider-2.png',
      'assets/images/slider-3.png'
    ];
  }

  getVideozConfig() {
    this.gameConfig.sliderName = 'noslider';
    this.gameConfig.title = 'Video Lounge';
    this.gameConfig.description =
      'Video app format that offers a multi-lingual videos with an option to upload videos and you can enjoy unlimited super features';

    this.gameConfig.imageList = ['assets/images/carousel-1 copy.png'];
  }

  getVideoConfig() {
    this.gameConfig.sliderName = 'videoSlider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/silde4.png',
      'assets/images/slider-5.png'
    ];

    console.log('this.videoConfig', this.gameConfig.imageList);
  }

  getYogaConfig() {
    this.gameConfig.sliderName = 'slider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/yoga1.png',
      'assets/images/yoga2.png',
      'assets/images/yoga4.png'
    ];
  }

  getConfigData(data: any, lang: any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.titleService.setTitle(this.gameConfig.header1);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getFaqData(data: any, lang: any) {
    this.apiService.getFAQData(data, lang).subscribe(
      (response: any) => {
        this.faq = response;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openDialog(): void {

    const modalRef = this.modal.open(MobileDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getMobileRes(mobileNumber: number, url:any){
    this.apiService.getMobileResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response === true){
          this.mobileNumber = mobileNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = this.mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
        }else{
          this.openDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getMobilePINRes(mobileNumber: number, pinNumber: number, operatorId: string, url: any){
    this.apiService.getMobilePINResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response !== null){
          this.queryParam.pin = pinNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));        }
          else{
          this.openLoginDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openLoginDialog(): void {
    const modalRef = this.modal.open(LoginDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

 getConditionalDialogBox(){    
    if(this.apiService.isRedirct(this.queryParam.id, this.queryParam.biller)){
          if(this.queryParam.msisdn == undefined){
            if(this.queryParam.id == '426'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1209;
            }else if(this.queryParam.id == '273'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1212;

            }
          }
    }else if((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966"){
      if(this.queryParam.mobileNumber === 0){
        this.queryParam.popup = true;
        this.openLoginDialog();
      }else{
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn="+this.queryParam.mobileNumber+"&pin="+this.queryParam.pin+"&operatorId="+this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    }else if((this.queryParam.id == '375') && this.queryParam.biller.toLowerCase() == "QANAWAT".toLowerCase()){
      if(this.queryParam.mobileNumber === 0){
        this.queryParam.popup = true;
        this.openLoginDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/qanawatKSAPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
      }
    }else if(this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if(this.portalIds.includes(this.queryParam.id) && this.queryParam.biller === 'TPAY' &&  this.operatorIds.includes(this.queryParam.operator)){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openLoginDialog();
      }else{
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn="+this.queryParam.mobileNumber+"&pin="+this.queryParam.pin+"&operatorId="+this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    }
  }
}
